import React from "react";
import { useTheme, Typography, Box } from "@mui/material";
import { getPageNotFoundStyle } from "../../components/customstyles/PageNotFoundStyle";

const useStyles = () => {
  const theme = useTheme();
  return getPageNotFoundStyle(theme);
};

function LoginError({ isAssessmentError = false }) {
  const styles = useStyles();

  return (
    <Box
      sx={{
        ...styles.logoutPageStyle,
        ...(isAssessmentError ? {} : styles.marginTop),
      }}
    >
      <Typography sx={styles.headingText}>An Error Has Occurred </Typography>
      <Typography sx={styles.subHeadingText}>
        Please exit and try the link again. If this issue persists, please
        complete AIMS assessment in the EHR.
      </Typography>
      <Typography sx={styles.subHeadingText}>
        To report this issue, please email{" "}
        <a href="mailto:eAims-Assessment@amalgamrx.com">
          eAims-Assessment@amalgamrx.com
        </a>
        .
      </Typography>
    </Box>
  );
}
export default LoginError;
